import { ApolloClient } from '@apollo/client';
import type { AnswerFragment } from '../../present/activity-answers.graphql.generated';
import type { GetClassStudentsAnswersSummaryPerComponentQuery } from '../../present/activity-answers.graphql.generated';
import { GET_CLASS_STUDENTS_ANSWERS_SUMMARY_PER_COMPONENT } from 'approot/activity-builder/present/activity-answers.graphql';
import { ActivitiesContentType } from 'global/constants';

export function updateStudentAnswersSummaryInCache({
  client,
  updatedAnswer,
  userClassId,
  contentId,
  contentType,
  contentVersion,
}: {
  client: ApolloClient<any>;
  updatedAnswer: AnswerFragment;
  userClassId: number;
  contentId: number;
  contentType: ActivitiesContentType;
  contentVersion: string;
}) {
  const classId = userClassId;
  const data =
    client.cache.readQuery<GetClassStudentsAnswersSummaryPerComponentQuery>({
      query: GET_CLASS_STUDENTS_ANSWERS_SUMMARY_PER_COMPONENT,
      variables: {
        input: {
          classId,
          componentId: updatedAnswer.componentId,
          contentId,
          contentType,
          contentVersion,
          loadDrawingData: false,
        },
      },
    });

  const dataInCache = data?.getClassStudentsAnswersSummaryPerComponent || [];
  // find the student
  const isExisting = dataInCache.find(
    a => a.studentId === updatedAnswer.studentId
  );

  client.cache.writeQuery<GetClassStudentsAnswersSummaryPerComponentQuery>({
    query: GET_CLASS_STUDENTS_ANSWERS_SUMMARY_PER_COMPONENT,
    data: {
      getClassStudentsAnswersSummaryPerComponent: isExisting
        ? dataInCache.map(summary => {
            if (summary.studentId === updatedAnswer.studentId) {
              return {
                __typename: 'StudentAnswerSummaryPerActivityComponent',
                lastAnswer: updatedAnswer,
                numberOfAttempts: summary.numberOfAttempts + 1,
                studentId: summary.studentId,
              };
            }
            return summary;
          })
        : [
            ...dataInCache,
            {
              __typename: 'StudentAnswerSummaryPerActivityComponent',
              lastAnswer: updatedAnswer,
              numberOfAttempts: 1,
              studentId: updatedAnswer.studentId!,
            },
          ],
    },
    variables: {
      input: {
        classId,
        contentId,
        contentType,
        contentVersion,
        componentId: updatedAnswer.componentId,
        loadDrawingData: false,
      },
    },
  });
}
